module.exports = __webpack_public_path__ + "static/media/logoLine.68d02a2d.webp";